// extracted by mini-css-extract-plugin
module.exports = {"settings__content":"styles_settings__content__1Y7uz"};